var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"load_wrap"}},[_c('div',{staticClass:"load"},[_c('lottie',{staticClass:"lottie",attrs:{"options":_vm.options}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }